import React from "react";

function SkeletonTitle(props) {
    const {
        count
    } = props;

    const SkeletonOutput = Array.apply(null, Array(count))
        .map((_, i) => (
            <div key={i} className={["tms-skeleton-title"].join(" ")} />
        ));

    return SkeletonOutput;

}

export default SkeletonTitle;
